import PortOutRequestsTable from "../../views/pages/port-out-requests/view";

import layouts from "../../layout";

export default [
  {
    path: "/port-out-requests",
    name: "port-out-requests",
    component: PortOutRequestsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["port out requests"],
      roles: [1, 11]
    }
  }
];
